import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import type { Permission } from '../../../auth/common/interfaces/permission';
import { AuthStore } from '../../../auth/common/stores/auth.store';
import { DashboardRoute } from '../../../dashboard/common/enums/dashboard-route';

export const permissionGuard = (permission: `${Permission}`): CanActivateFn => {
  return () => {
    const authStore = inject(AuthStore);
    const router = inject(Router);

    return authStore.hasPermission(permission)
      ? true
      : router.createUrlTree([DashboardRoute.ORDERS]);
  };
};
